module.exports = __webpack_public_path__ + "img/back_top.acf93fc9.png";